import React from "react";
import "../../../css/HomeScreenOfferTemplate.css";
import { useNavigate } from "react-router-dom";
import { formatOfferDate } from "../../../constant/formatOfferDate";

export const HomeScreenOfferTemplate = ({
	data,
	previewUrl,
	clickable = true,
	distanceKm,
}) => {
	const navigate = useNavigate();
	const navigateToOfferDetails = () => {
		navigate("/offer-details", {
			state: { data: data, distanceKm: distanceKm },
		});
	};

	return (
		<div className="card-wrapper">
			<div
				className="home-offer-image"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();

					navigateToOfferDetails();
				}}
			>
				<img src={data.image || previewUrl} alt="" />
				{data.offerType ? (
					<span className="discount-badge">
						{/* =========================================
		   FLAT OFFER
		========================================= */}

						{data.offerType.toLowerCase() === "flat" &&
							data.offerValue && (
								<span>Rs. {data.offerValue} OFF</span>
							)}

						{/* =========================================
		   PERCENT OFFER
		========================================= */}

						{data.offerType.toLowerCase() === "percent" &&
							data.offerValue && (
								<span>{data.offerValue}% OFF</span>
							)}

						{/* =========================================
		   OTHER OFFER TYPES
		========================================= */}

						{["combo", "buy 1 get 1", "buy 2 get 1"].includes(
							data.offerType.toLowerCase(),
						) && <span>{data.offerType.toUpperCase()}</span>}
					</span>
				) : (
					<div className="d-flex home-discount-badge">
						{data.offerType || "❤️"}
					</div>
				)}
			</div>
			<div className="home-offer-body pt-3 px-3">
				<div className="text-left">
					<h5>
						{data.shopName?.charAt(0).toUpperCase() +
							data.shopName?.slice(1)}
					</h5>
				</div>
				<div className="text-left description-color">
					<h6>{data.title}</h6>
				</div>
				<div className="start-end-date text-left">
					<span className="pr-1">📅</span>
					{data.startDate
						? `Valid:  ${formatOfferDate(data.startDate)} - ${formatOfferDate(data.endDate)}`
						: `Valid: - ${formatOfferDate(data.endDate)}`}
				</div>
				{/* <div className="text-left pt-3 calculated-distance">
					<i class="fa-solid fa-location-arrow pr-2"></i>
					<span>{data.calculatedDistance} km</span>
				</div> */}
			</div>
		</div>
	);
};
